import React from "react";
import { Select } from "antd";
import { FaAngleDown } from "react-icons/fa6";

const QuestionnaireDropdown = (props) => {
  return (
    <Select
      className="questionnaire-dropdown w-full"
      placeholder={props?.placeholder ?? "Please Select"}
      suffixIcon={<FaAngleDown />}
      value={props?.value ?? null}
      showSearch
      {...props}
    >
      {props?.array?.map((item, index) => (
        <Select.Option value={item} key={index}>
          {item}
        </Select.Option>
      ))}
    </Select>
  );
};

export default QuestionnaireDropdown;
